/**
 * 
 * @param {*} input 
 * Example:
 * BQN CPU   USER   NICE    SYS  IO-WA    IRQ   SOFT  STEAL  GUEST   IDLE
241 all   0.05   0.00   0.05   0.00   0.00   0.00   0.00   0.00  99.90
241   0   0.21   0.00   0.00   0.21   0.00   0.00   0.00   0.00  99.59
241   1   0.00   0.00   0.00   0.00   0.00   0.00   0.00   0.00 100.00
241   2   0.00   0.00   0.00   0.00   0.00   0.00   0.00   0.00 100.00
241   3   0.00   0.00   0.21   0.00   0.00   0.00   0.00   0.00  99.79
CPU   USER   NICE    SYS  IO-WA    IRQ   SOFT  STEAL  GUEST   IDLE
all   0.12   0.00   0.00   0.00   0.00   0.00   0.00   0.00  99.88
  0   0.00   0.00   0.00   0.00   0.00   0.00   0.00   0.00 100.00
  1   0.23   0.00   0.00   0.00   0.00   0.00   0.00   0.00  99.77
  2   0.00   0.00   0.23   0.23   0.00   0.00   0.00   0.00  99.53
  3   0.00   0.00   0.00   0.00   0.00   0.00   0.00   0.00 100.00
 * @returns 
 */

const HEADER_KEYS_MAP = {
  BQN: "bqn",
  CPU: "cpu",
  USER: "user",
  NICE: "nice",
  SYS: "sys",
  "IO-WA": "ioWait",
  IRQ: "irq",
  SOFT: "soft",
  STEAL: "steal",
  GUEST: "guest",
  IDLE: "idle",
};
export const parseSystemCPUUsage = (input) => {
  const [header, ...rows] = input.trim(/\s/).split("\n");
  const headerAttrs = header.trim(/\s/).split(/\s+/);
  const attrsMap = headerAttrs.reduce((acc, attr, index) => {
    acc[index] = attr;
    return acc;
  }, {});
  return rows.map((row) => {
    const rowAttrs = row.trim("s").split(/\s+/);
    return rowAttrs.reduce((acc, attr, index) => {
      const key = HEADER_KEYS_MAP[attrsMap[index]];
      if (key === "cpu") {
        acc[key] = `CPU${attr}`;
      } else {
        acc[key] = isNaN(attr) ? attr : Number(attr);
      }
      return acc;
    }, {});
  });
};
